import {
  Box,
  Card,
  Group,

  Text,
} from "@mantine/core";
import { Title } from "../components";

type Props = {
  id: string;
};

const SERVICES = [
  "冷氣維修保養年檢",
  "冷氣清洗服務",
  "購買冷氣",
  "冷氣睇位及安裝",
  "新裝修住宅及寫字樓清潔及除甲醛",
  "消毒噴霧服務",
  "住宅水電維修服務",
  "提供水電冷24小時緊急服務",
  "住宅工商電力檢查(WR2)",
];

export default function OurService({ id }: Props) {
  return (
    <section id={id}>
      <Title
        title="我們的服務"
        description="我們的專業團隊有超過10年的經驗，幫助客戶解決各種冷氣及水電問題。"
      />
      <Box
        sx={(theme) => ({
          padding: theme.spacing.xl,
          borderRadius: theme.radius.md,
          backgroundColor: theme.white,
          marginBottom: theme.spacing.sm,
        })}
      >
        <Group my={"lg"} position="center">
          {SERVICES.map((service) => (
            <Card padding="md" radius="md" withBorder key={service}>
              <Text c="dimmed">{service}</Text>
            </Card>
          ))}
        </Group>
      </Box>
    </section>
  );
}
